import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageLayout from '../components/PageLayout';
import Button from '../components/Button';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <PageLayout>
      <div style={{
        textAlign: 'center',
        padding: '80px 20px',
        maxWidth: '600px',
        margin: '0 auto'
      }}>
        <div style={{ fontSize: '120px', fontWeight: 'bold', color: '#ddd' }}>
          404
        </div>
        <h1 style={{ marginTop: '20px', marginBottom: '10px' }}>
          Page Not Found
        </h1>
        <p style={{
          fontSize: '18px',
          color: '#666',
          marginBottom: '40px',
          lineHeight: '1.6'
        }}>
          Sorry, the page you're looking for doesn't exist. It may have been moved or deleted.
        </p>
        <div style={{
          display: 'flex',
          gap: '16px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <Button
            onClick={() => navigate(-1)}
            variant="secondary"
          >
            Go Back
          </Button>
          <Button
            onClick={() => navigate('/')}
            variant="primary"
          >
            Go Home
          </Button>
        </div>
      </div>
    </PageLayout>
  );
};

export default NotFound;
